import { createRouter, createWebHistory } from 'vue-router';

import User from './user-profile/user-profile.vue';
import Users from './account-users/account-users.vue';
import PlanAndBilling from './plan-and-billing/plan-and-billing.vue';
import { currentUser, EntitelmentTypes } from '@mfl/platform-shell';

const childrenRoutes = [];

childrenRoutes.push({
  name: 'account-settings-users',
  path: 'users',
  component: Users,
});

if (currentUser.isEntitledTo(EntitelmentTypes.accountUsers)) {
  childrenRoutes.push({
    name: 'account-settings-user-profile',
    path: 'user-profile',
    component: User,
  });
}

childrenRoutes.push({
  name: 'account-settings-plan-and-billing',
  path: 'plan-and-billing',
  component: PlanAndBilling,
});

const routes = [
  {
    name: 'account-settings',
    path: '/v1/account-settings',
    redirect: { name: 'account-settings-users' },
    children: childrenRoutes,
  },
];

export const router = createRouter({
  history: createWebHistory(''),
  routes,
});
